import { useState } from "react";
import { useI18n } from "@/i18n";
import { useTx } from "@/i18n/Tx";

// Note body with an "ES/EN" toggle when the record keeps a different-language original.
export function NoteText({ note, text, className = "" }) {
  const { lang, t } = useI18n();
  const [showOrig, setShowOrig] = useState(false);
  const n = note || {};
  const base = text ?? n.text ?? n.note ?? "";
  const translated = useTx(base, n.text_original, n.text_lang);
  const origLang = n.text_lang;
  if (!n.text_original || !origLang || origLang === lang) return <span className={className}>{translated}</span>;
  return (
    <span className={className} data-testid="note-text">
      {showOrig ? n.text_original : translated}
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); setShowOrig((s) => !s); }}
        title={showOrig ? t("Show translation") : t("Show the technician's original wording")}
        className="ml-1 inline-flex items-center rounded border border-slate-300 px-1 text-[9px] font-semibold uppercase leading-4 text-slate-500 hover:bg-slate-100 not-italic align-middle"
        data-testid="note-original-toggle"
      >
        {showOrig ? lang.toUpperCase() : origLang.toUpperCase()}
      </button>
    </span>
  );
}

export default NoteText;
